import React from 'react';
import RebelVillaList from './rebel-villa-list';

const RebelSettingsList = () => {
    return (
        <React.Fragment>
            <RebelVillaList />
        </React.Fragment>
    );
}

export default RebelSettingsList;
